import React, { memo, SVGProps } from 'react'

export const Underline = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.9264 16.5398H8.07358C7.67614 16.5398 7.35358 16.8624 7.35358 17.2598C7.35358 17.6573 7.67614 17.9798 8.07358 17.9798H15.9264C16.3238 17.9798 16.6464 17.6573 16.6464 17.2598C16.6464 16.8624 16.3238 16.5398 15.9264 16.5398Z"
      fill="currentColor"
    />
    <path
      d="M15.9264 6.02016C15.5289 6.02016 15.2064 6.34272 15.2064 6.74016V10.7453C15.2064 12.3859 13.7683 13.7213 12 13.7213C10.2317 13.7213 8.79358 12.3859 8.79358 10.7453V6.74016C8.79358 6.34272 8.47102 6.02016 8.07358 6.02016C7.67614 6.02016 7.35358 6.34272 7.35358 6.74016V10.7453C7.35358 13.1798 9.43774 15.1613 12 15.1613C14.5622 15.1613 16.6464 13.1808 16.6464 10.7453V6.74016C16.6464 6.34272 16.3238 6.02016 15.9264 6.02016Z"
      fill="currentColor"
    />
  </svg>
))
